<div class="deal-activity-wrapper">
    <div class="description text-wrap leading-tight">
        {{description}}
    </div>
    <div class="actor leading-none mt-1">
        {{action}}
        <span>{{actor}}</span>
    </div>
</div>
